import { useState } from 'react';
import { api } from '../lib/api.js';
import { fmtDate } from '../lib/format.js';

// ─── Team directory (Settings → Team) ────────────────────────────────────────
// Round 7: read-only directory visible to everyone for shift-coverage
// Hiring v3 / Ticket F3 — Mentor-required dashboard alert.
// Renders above the Hiring list when there are recent hires without a
// mentor assigned. Inline picker lets the manager assign one without
// leaving the page. Server-side filter scopes to the manager's
// location(s) (owners see all).
export function MentorRequiredAlert({ hires, headers, onAssigned }) {
  const [openFor, setOpenFor] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [savingFor, setSavingFor] = useState(null);

  function open(userId, locId) {
    setOpenFor(userId);
    setCandidates([]);
    api('GET', `/api/admin/mentor-candidates?location_id=${locId}`, null, headers)
      .then(r => setCandidates(Array.isArray(r?.candidates) ? r.candidates : []))
      .catch(() => setCandidates([]));
  }
  async function assign(userId, mentorId) {
    setSavingFor(userId);
    try {
      await api('PUT', `/api/admin/users/${userId}/mentor`,
        { mentor_user_id: mentorId }, headers);
      setOpenFor(null);
      onAssigned();
    } catch (e) { alert(e.message || String(e)); }
    finally { setSavingFor(null); }
  }
  function fmtDate(d) {
    if (!d) return '';
    try { return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch { return ''; }
  }
  return (
    <div style={{ padding: 14, background: '#fff8e6', border: '1px solid #f0d9a3',
                  borderLeft: '4px solid var(--gold)', borderRadius: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#7a5b1a',
                    textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
        Mentor needed · {hires.length}
      </div>
      <div style={{ fontSize: 13, color: '#444', marginBottom: 10 }}>
        Recent hires without a mentor assigned. Pair them up before their first shift.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {hires.map(h => (
          <div key={h.id} style={{ background: '#fff', border: '1px solid #f0d9a3',
                                    borderRadius: 6, padding: 8, fontSize: 13 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
                          flexWrap: 'wrap', gap: 8 }}>
              <span>
                <strong>{h.name}</strong> · {h.role || 'staff'} at {h.location_name || '—'}
                {' · hired '}{fmtDate(h.hire_date)}
              </span>
              {openFor !== h.id && (
                <button onClick={() => open(h.id, h.primary_location_id)}
                  style={{ fontSize: 11, padding: '3px 12px', border: '1px solid var(--gold)',
                            background: 'var(--cream, #fef9ee)', borderRadius: 4,
                            cursor: 'pointer', fontWeight: 600 }}>
                  Assign mentor
                </button>
              )}
            </div>
            {openFor === h.id && (
              <div style={{ marginTop: 8, display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                {candidates.length === 0 ? (
                  <span style={{ fontSize: 12, color: '#888' }}>
                    No teammates flagged eligible-as-mentor at this location yet. Open a profile and turn on the toggle.
                  </span>
                ) : (
                  <>
                    {candidates.map(c => (
                      <button key={c.id} onClick={() => assign(h.id, c.id)}
                        disabled={savingFor === h.id}
                        style={{ fontSize: 11, padding: '3px 10px', border: '1px solid #c8e2c8',
                                  borderRadius: 99, background: '#fff', cursor: 'pointer' }}>
                        {c.name}{c.role ? ` (${c.role})` : ''}
                      </button>
                    ))}
                    <button onClick={() => setOpenFor(null)}
                      style={{ fontSize: 11, color: '#888', background: 'none', border: 0, cursor: 'pointer' }}>
                      cancel
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
